import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from '../../store';
import {
  required, maxLength
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "examCreate",
  components: {
    MainLayout,
    Select2Multiple,
    flatPickr,
    Loading
  },

  data() {
    return {
      isLoading: false,
      classData: {},
      selectedClass: [],
      selectedSubjects: [],
      classArr: [],
      gradeArr: [],
      subjectArr: [],
      academic_year: '',
      academicYear: '',
      campusGradeId: '',
      exam_name: '',
      exam_start_date: '',
      exam_end_date: '',
      academicYearArr: null,
      gradingArr: null,
      submitted: false,
      id: 0,
      isError: false,
      fullMarkErrors: [],
      passMarkErrors: [],
      distinctionMarkErrors: [],
    };
  },

  validations: {
    academic_year: {
      required
    },
    exam_start_date: {
      required
    },
    exam_end_date: {
      required
    },
    exam_name: {
      required,
      maxLength: maxLength(100)
    },
  },

  methods: {
    getCurrentPeriodList() {
      axios.get('/period/getCurrentPeriodList', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Academic Year'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        })
        .catch(this.logout);
    },

    changeEvent(val, fieldName) {
      this.submitted = false;
      this.isLoading = true;
      this.$set(this, fieldName, val);

      switch (fieldName) {
        case "academic_year":
          this.campusGradeId = '';
          this.selectedClass =
          this.gradeArr =
          this.classArr = [];
          this.subjectArr = [];
          this.selectedSubjects = [0];
          this.getGrading(val);
          break;
        case "campusGradeId":
          this.selectedClass =
          this.classArr = [];
          this.subjectArr = [];
          this.selectedSubjects = [0];
          this.getClass(val);
          this.getSubjects(val);
          break;
      }
      this.isLoading = false;
    },

    getGrading(academic_year) {
      if (!+academic_year) return;

      axios.get("campusGrade/list-by-acdYear/", {
        params: {
          campus_id: store.state.user.campus_id,
          acd_year_id: academic_year,
          get_grade: true,
        }
      }).then(res => {
        this.gradeArr = res.data.map(grade => {
          return {
            id: grade.campus_grade_id,
            text: grade.grade_name
          }
        })
      })
      .catch(this.logout)
    },

    getClass(campusGradeId) {
      if (!+campusGradeId) return;

      axios.get("class/sectionList/", {
        params: {
          campus_id: store.state.user.campus_id,
          campus_grade_id: campusGradeId,
        }
      })
      .then((res) => {
          if (res.data.length > 0) {
            let classList = res.data.map(section => {
              return {
                id: section.id,
                text: `${section.grade_name} (${section.text})`
              }
            });
            this.classArr = [{id: 0, text: 'All'}].concat(classList);
          } else {
            this.classArr = [];
          }
      })
      .catch(this.logout);
    },

    logout(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
    },

    getSubjects(campusGradeId) {
      if (!+campusGradeId) return;

      axios.get('subject/subjectByGradeId/' + campusGradeId, {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
      .then(res => {
        const subjects = res.data.subjectArr[0] || [];
        this.subjectArr = subjects.map(subject => ({
          id: subject.id,
          text: subject.subject_name || subject.text, 
          full_mark: '',
          pass_mark: '',
          distinction_mark: '',
          selected: true
        }));
        this.selectedSubjects = this.subjectArr.map(s => s.id); 
      })
      .catch(this.logout);
    },

    confirmRegister() {
      this.id = 0;
      this.submitted = true;
      this.isLoading = true;
      this.fullMarkErrors = [];
      this.passMarkErrors = [];
      this.distinctionMarkErrors = [];

      if (this.exam_start_date && this.exam_end_date && new Date(this.exam_end_date) < new Date(this.exam_start_date)) {
        this.isError = true;
      } else {
        this.isError = false;
      }

      this.subjectArr
        .filter(s => this.selectedSubjects.includes(s.id))
        .forEach(subject => {
            if (subject.full_mark && (subject.full_mark > 100 || subject.full_mark <= 0)) {
              this.fullMarkErrors.push(subject.id);
            }
            if (subject.pass_mark && (subject.pass_mark > 100 || subject.pass_mark <= 0)) {
              this.passMarkErrors.push(subject.id);
            }

            if (subject.distinction_mark && (subject.distinction_mark > 100 || subject.distinction_mark <= 0)) {
              this.distinctionMarkErrors.push(subject.id);
            }
        });

      if (this.$v.$invalid || !this.selectedClass.length || !this.academic_year.length || this.isError) {
        this.isLoading = false;
        return;
      }
      if (!this.subjectArr.length) {
        this.isLoading = false;
        return;
      }
      if (!this.selectedSubjects.length) {
        this.isLoading = false;
        return;
      }

      if (this.fullMarkErrors.length || this.passMarkErrors.length || this.distinctionMarkErrors.length) {
        this.isLoading = false;
        return;
      }
      this.register();
    },

    prepareData(selectedArr, itemsArray) {
      const isAll = selectedArr.length && selectedArr.map(i => +i).includes(0);
      return (isAll ? itemsArray : selectedArr).map(item => isAll ? item.id : +item).filter(id => id);
    },

    register() {
      const selectedSubjectsData = this.subjectArr
        .filter(s => this.selectedSubjects.includes(s.id))
        .map(s => ({
          id: s.id,
          full_mark: s.full_mark,
          pass_mark: s.pass_mark,
          distinction_mark: s.distinction_mark
        }));
      
      var request = {
        academic_year: this.academic_year,
        class_id: this.prepareData(this.selectedClass, this.classArr),
        exam_name: this.exam_name,
        exam_start_date: this.exam_start_date,
        exam_end_date: this.exam_end_date,
        campus_grade_id: this.campusGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id,
        subjects: selectedSubjectsData,
      }

      axios.post("/exam/create", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          if (response.data.status == 200) {
            this.isLoading = false;
            this.$notification.success("Exam Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "examList"
            });
          }
          else if (response.data.success == false) {
            this.isLoading = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
          else if (response.data.status == 201) {
            this.isLoading = false;
            this.$notification.error("Exam data already exist.", {
              timer: 3,
              position: "bottomCenter",
            });
          } else {
            this.isLoading = false;
            this.$notification.error("something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Exam Create API Error", error.errors);
        });
    },

    showList() {
      this.$router.push({
        path: "/exam/list"
      });
    },

    onSubjectCheckboxChange(subject) {
      subject.selected = this.selectedSubjects.includes(subject.id);
      if (!subject.selected) {
        subject.full_mark = null;
        subject.pass_mark = null;
        subject.distinction_mark = null;
        this.fullMarkErrors = [];
        this.passMarkErrors = [];
        this.distinctionMarkErrors = [];
      }
    },
  },

  mounted() {
    this.isLoading = true;
    this.getCurrentPeriodList();
  },
};
